import React, { createContext, useRef, useEffect } from 'react';
import { Table } from 'semantic-ui-react';
import LogMessageAccordionRow from './LogMessageAccordionRow.jsx';
import useToggle from '../hooks/useToggle.jsx';

const RowContext = createContext({});

export default function LogTableRow({ message, ...props }) {
  const toggle = useToggle(false);
  const messageRowRef = useRef();

  useEffect(() => {
    if (messageRowRef.current) {
      messageRowRef.current.innerHTML = message;
    }
  }, [message]);

  if (!message) {
    return <Table.Row {...props} />;
  }

  return (
    <RowContext.Provider
      value={{ handleClick: toggle.toggle, isClicked: toggle.value }}
    >
      <LogMessageAccordionRow
        {...props}
        ref={messageRowRef}
        active={toggle.value}
      />
    </RowContext.Provider>
  );
}

LogTableRow.Context = RowContext;
